/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StringStringBaseDropDownListViewModel } from "../types/StringStringBaseDropDownListViewModel.ts";

export const stringStringBaseDropDownListViewModelSchema = z.object({
  key: z.string().nullish(),
  value: z.string().nullish(),
}) as unknown as ToZod<StringStringBaseDropDownListViewModel>;
